import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex } from "@chakra-ui/react";
import NextImage from "next/image";
import { defineMessages, FormattedMessage } from "react-intl";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import React from "react";
const messages = defineMessages({
  headerLogin: {
    id: "header.login",
    defaultMessage: "Login"
  }
});
export const Header: React.FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NextImage src="/logo.svg" alt="Mobilysis" height={40} width={200} data-testid="header-logo" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box as="header" position="absolute" top="0" left="0" right="0" zIndex="10" px="4" pt="3" data-testid="header"><Flex bg="white" borderRadius="pill" px="8" py="3" align="center" justify="space-between" boxShadow="elevated">{t0}<Button disabled={true} bg="grey.500" color="white" borderRadius="button" px="4" py="2" fontSize="sm" _hover={t1} data-testid="header-login-button"><FormattedMessage {...messages.headerLogin} /><AssignmentIndIcon fontSize="small" /></Button></Flex></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};